export const SiteFooter = ({ t }) => (
  <footer data-testid="site-footer" className="border-t border-[#272A2E] py-16 bg-[#050505]">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-10">
      <div>
        <p className="font-display font-black tracking-tighter text-white text-lg uppercase">Shadow<span className="text-[#FF2A00]">Shield</span></p>
        <p data-testid="footer-text" className="mt-4 text-xs font-mono tracking-[0.15em] text-[#8A8F98] leading-relaxed">{t.footer}</p>
      </div>
      <div data-testid="footer-owner">
        <p className="text-[10px] font-mono tracking-[0.2em] uppercase text-[#FF2A00]">{t.owner.label}</p>
        <p className="mt-3 font-display text-lg font-bold uppercase text-white tracking-tight">{t.owner.name}</p>
        <p className="mt-2 text-xs font-mono text-[#8A8F98] leading-relaxed">{t.owner.addr}</p>
        <a href={`mailto:${t.owner.email}`} data-testid="footer-email" className="mt-2 inline-block text-xs font-mono text-[#8A8F98] hover:text-[#FF2A00] border-b border-[#272A2E] pb-0.5 transition-colors duration-300">{t.owner.email}</a>
      </div>
      <div className="md:text-right">
        <a href="/galleria" data-testid="footer-gallery" className="inline-block text-xs font-mono tracking-[0.15em] uppercase border border-[#FF2A00] text-[#FF2A00] px-5 py-3 hover:bg-[#FF2A00] hover:text-black transition-colors duration-300">{t.galleryPage.title} →</a>
        <p className="mt-6 text-xs font-mono tracking-[0.2em] text-[#4A4F58]">PRFV // RAL 7016 // NIR 850–940nm</p>
      </div>
    </div>
  </footer>
);
